import { render, staticRenderFns } from "./ReviewTab.vue?vue&type=template&id=7ca206c8&scoped=true&"
import script from "./ReviewTab.vue?vue&type=script&lang=js&"
export * from "./ReviewTab.vue?vue&type=script&lang=js&"
import style0 from "./ReviewTab.vue?vue&type=style&index=0&id=7ca206c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca206c8",
  null
  
)

export default component.exports